module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"label-btn-add":"Hinzufügen"},"fr":{"label-btn-add":"Ajouter"},"it":{"label-btn-add":"Inserire"}}')
  delete Component.options._Ctor
}
